import React, { useEffect, useState } from "react";
import Header from "../../Core/Header";
import {
  diagnosticList,
  doctorList,
  getAgentList,
  getAllBookedTests,
  getAudioMetres,
  getGst,
  getMedicalTechnicianList,
  getPatientById,
  getServiceBoyList,
  getShopOwnerList,
  hospitalList,
  patientList,
  storeTypeList,
  subServiceList,
  testBookMaking,
  updatePatientById,
  userList,
  vendorList,
} from "../../Services/Operations/ProductAPI";
import { Section } from "../../Core/Section";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

const box = {
  border: "1px solid #1a2a6c",
  padding: "8px",
  marginBottom: "6px",
};

const label = { fontWeight: "bold" };

const row = {
  display: "flex",
  justifyContent: "space-between",
  marginBottom: "4px",
  fontSize: "14px",
};

const tableCell = {
  border: "1px solid #1a2a6c",
  padding: "6px",
  textAlign: "center",
  fontSize: "14px",
};

const Patient = () => {
  const [patient, setPatient] = useState([]);
  const [currentpatient, setCurrentpatient] = useState(null);
  const [modal, setModal] = useState(false);
  const [editModal, setEditModal] = useState(null);
  const token = useSelector((state) => state.user.token);
  console.log("token : ", token);
  const [serviceBoys, setServiceBoys] = useState("");
    const [mediaclTechnician, setMediaclTechnician] = useState("");
  const [selectedServicePerson, setSelectedServicePerson] = useState("");
  const [service, setService] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [storeList, setStoreList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const [searchKey, setSearchKey] = useState("");
  const itemsPerPage = 10;

  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;



  const [gstPercent, setgstPercent] = useState("");
  const [gstAmount, setgstAmount] = useState("");
  const [totalAmountWithoutGst, settotalAmountWithoutGst] = useState("");
  const [totalAmountWithGst, settotalAmountWithGst] = useState("");
  const [discountAmount, setdiscountAmount] = useState("");
  const [gstList, setGstList] = useState([]);
  const [allBookedTest, setAllBookedTests] = useState([]);
  const [testModal, setTestModal] = useState(null);
  const [allTestModal, setAllTestModal] = useState(null);
  const [isAgent, setIsAgent] = useState(false);
  const [isDiagnostic, setIsDiagnostic] = useState(false);
  const [isDoctor, setIsDoctor] = useState(false);
  const [isHospital, setIsHospital] = useState(false);
  const [isShop, setIsShop] = useState(false);
  const [isStore, setIsStore] = useState(false);
  const [isVendor, setIsVendor] = useState(false);
  const [selectedAgent, setselectedAgent] = useState("");
  const [selectedDoctor, setselectedDoctor] = useState("");
  const [selectedDiagnostic, setselectedDiagnostic] = useState("");
  const [selectedHospital, setselectedHospital] = useState("");
  const [selectedShop, setselectedShop] = useState("");
  const [selectedStore, setselectedStore] = useState("");
  const [selectedVendor, setselectedVendor] = useState("");

  const [agentList, setAgentLsit] = useState([]);
  const [doctors, setDoctors] = useState([]);
  const [hospital, setHospital] = useState([]);
  const [diagnostic, setDiagnostic] = useState([]);
  const [shop, setShop] = useState([]);
  const [vendor, setVendor] = useState([]);
  const [storeOwner, setStoreOwner] = useState([]);
  const [user, setUser] = useState([]);

  const [refers, setRefers] = useState([]);

  const [selectedservicePersonId, setSelectedServicePersonId] = useState(null);
  const [selectedStoreId, setselectedStoreId] = useState(null);
  const [filteredList, setFilterdList] = useState([]);
 

  const handleFetchAgentList = async () => {
    try {
      const response = await getAgentList(token);
      console.log("agents :", response.data);
      setAgentLsit(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchDoctorList = async () => {
    try {
      const response = await doctorList(token);
      setDoctors(response);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const fetchHospitalList = async () => {
    try {
      const response = await hospitalList(token);
      setHospital(response);
      console.log("hospitalList", response);
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const fetchDiagnosticList = async () => {
    try {
      const response = await diagnosticList(token);
      setDiagnostic(response);
      console.log("hospitalList", response);
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const handleFetchShop = async () => {
    try {
      const response = await getShopOwnerList(token);
      console.log(response);
      setShop(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchVendorList = async () => {
    try {
      const response = await vendorList(token);
      console.log("Vendor : ", response);
      setVendor(response);
    } catch (error) {
      console.error("Error fetching subcategories:", error);
    }
  };

  const fetchStoreOwner = async () => {
    try {
      const response = await storeTypeList(token);
      console.log(response);

      setStoreOwner(response);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const fetchServiceList = async () => {
    try {
      const response = await subServiceList(token);
      console.log("service  list:", response);
      setService(Array.isArray(response) ? response : []);
    } catch (error) {
      console.error("Error updating profile:", error);
    }
  };

  const fetchServieBoys = async () => {
    if (!token) {
      navigate("/login");
      return;
    }

    try {
      const response = await getServiceBoyList(token);
      console.log("serice boy  List: ", response);
      setServiceBoys(response);
    } catch (error) {
      console.log(error);
    }
  };
   const fetchMedicalTechnicialList = async () => {
    if (!token) {
      navigate("/login");
      return;
    }

    try {
      const response = await getMedicalTechnicianList(token);
      console.log("medical technician  List: ", response);
      setMediaclTechnician(response);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchStoreList = async () => {
    try {
      const res = await storeTypeList(token);

      setStoreList(res);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchUserList = async () => {
    try {
      const response = await userList(token);
      console.log("user list:", response);

      setUser(response);
    } catch (error) {
      console.error("Error updating profile:", error);
    }
  };

  useEffect(() => {
    const fetchPatientList = async () => {
      try {
        const response = await patientList(token);
        setPatient(response);
       
     
        console.log("patientList", response);
      } catch (error) {
        console.error("Error:", error);
      }
    };
    const fetchAudioMeters = async () => {
      try {
        const response = await getAudioMetres(token);

        console.log("getAudioMetres", response);
      } catch (error) {
        console.error("Error:", error);
      }
    };
    const fetchGstList = async () => {
      try {
        const response = await getGst(token);
        setGstList(response);
        console.log("fetchGstList", response);
      } catch (error) {
        console.error("Error fetching GST list:", error);
      }
    };
    fetchMedicalTechnicialList()

    fetchAudioMeters();
    fetchPatientList();
    fetchServiceList();
    fetchServieBoys();
    fetchGstList();
    fetchStoreList();
    handleFetchAgentList();
    fetchDoctorList();
    fetchHospitalList();
    fetchDiagnosticList();
    handleFetchShop();
    fetchVendorList();
    fetchStoreOwner();
    fetchUserList();
  }, []);

  const handleServiceChange = (serviceId) => {
    setSelectedServices((prev) => {
      const exists = prev.find((s) => s.serviceId === serviceId);

      if (exists) {
        return prev.filter((s) => s.serviceId !== serviceId);
      }

      return [
        ...prev,
        {
          serviceId,
          audiometerId: "",
          servicePersonId: selectedServicePerson || "",
        },
      ];
    });
  };

  const handleAudiometerChange = (serviceId, audiometerId) => {
    setSelectedServices((prev) =>
      prev.map((s) => (s.serviceId === serviceId ? { ...s, audiometerId } : s)),
    );
  };

  const handleGetPatientById = async (id) => {
    try {
      let data = {
        id,
        token,
      };
      const res = await getPatientById(data);
      console.log(res);
      if (res.status === 200) {
        setCurrentpatient(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handlePersonupdate = async () => {
    const priceMap = new Map(
      service.map((item) => [item.id, item.servicePrice]),
    );

    const totalPrice = selectedServices.reduce((sum, item) => {
      return sum + (priceMap.get(item.serviceId) || 0);
    }, 0);

    let data = {
      serviceAudiometers: selectedServices,

      totalAmountWithoutGst: totalPrice,
      discountAmount,
      grandTotalAmount: totalPrice - discountAmount,
      paymentStatus: "PAID",
      paymentMode: "UPI",
      paymentReference: "UTR123456",
      totalServices: selectedServices.length,
      // gstId:gstPercent.id
      // gstAmount,
      // gstPercent:gstPercent.gstPercent,
      // totalAmountWithGst,
    };
    try {
      const formData = new FormData();
      formData.append("data", data);
      formData.append("patientImage", currentpatient.patientImage);
      formData.append("prescriptionImage", currentpatient.prescriptionImage);
      console.log(
        data,
        currentpatient.patientImage,
        currentpatient.prescriptionImage,
      );

      if (!currentpatient.patientImage || !currentpatient.prescriptionImage) {
        console.log("image is not availabe");
        return;
      }

      let body = {
        token,
        body: formData,
        id: editModal.id,
      };

      const res = await updatePatientById(body);
      console.log(res);
    } catch (error) {
      console.log(error);
    } finally {
      console.log(data);
    }
  };

  const handleCheckbox = (item, checked) => {
    if (checked) {
      // add
      setSelectedServices((prev) => [...prev, item]);
    } else {
      // remove
      setSelectedServices((prev) => prev.filter((s) => s.id !== item.id));
    }
  };

  const totalPrice = selectedServices.reduce(
    (sum, item) => sum + Number(item.servicePrice || 0),
    0,
  );

  const [discount, setDiscount] = useState("");
  const [advance, setAdvance] = useState("");

  const handleTestBookSubmit = async () => {
    try {
      const data = {
        services: selectedServices.map((i) => ({
          serviceId: i.id,
          medicalTechnicianId: Number(selectedservicePersonId), // same for all
          executingStoreId:Number(selectedStoreId),
          scheduleStartTime:i.scheduleStartTime,
          scheduleEndTime:i.scheduleEndTime,
        })),
        patientId:Number(testModal.id),
        totalAmountWithoutGst: Number(totalPrice),
        discountAmount: Number(discount),
        grandTotalAmount: Number(totalPrice - discount),
        paidAmount: Number(advance),
        paymentStatus: totalPrice>advance?"PARTIAL":"PAID",
        paymentMode: "Cash",
        paymentReference: "UTR123456",
        totalServices: selectedServices.length,
        storeId: Number(selectedStoreId),
        referrals: refers.map((i) => ({
          referralCommonUserId: i.commonUserId,
          referralType: i.type,
        })),
      };

      const formData = new FormData();

      // attach JSON as string (matches Postman/cURL)
      formData.append(
        "data",
        new Blob([JSON.stringify(data)], { type: "application/json" }),
      );

      // attach files (make sure these are File objects from input)
      if (testModal.prescriptionImage) {
        formData.append("prescriptionImage", testModal.prescriptionImage);
      }

      if (testModal.patientImage) {
        formData.append("patientImage", testModal.patientImage);
      }

      console.log(data, refers);

      const res = await testBookMaking(formData, testModal.id, token);

      console.log(res);
      if (res.status == 200) {
        toast.success("Test booked successfully");
        setTestModal(null);
        setSelectedServicePerson(null);
        setSelectedServices([]);
        setRefers([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleGetAllTest = async () => {
    try {
      const res = await getAllBookedTests(token);
      console.log("getAllBookedTests", res);
      const billsArray = Object.values(res.data).flat();

      const groupedBills = Object.values(
        billsArray.reduce((acc, item) => {
          const billId = item.bill.id;

          if (!acc[billId]) {
            acc[billId] = {
              ...item.bill,
              patient: {
                name: item.patientName,
                phone: item.patientPhone,
                address: item.patientAddress,
              },
              services: [],
            };
          }

          acc[billId].services.push({
            name: item.serviceName,
            price: item.price || 0,
          });

          return acc;
        }, {}),
      );

      setAllBookedTests(groupedBills);
    } catch (error) {
      console.log(error);
    }
  };

         let currentPatients = patient.slice(indexOfFirst, indexOfLast); 




const handleSearckByKey = () => {
  const key = searchKey.trim().toLowerCase();

  if (!key) {
   
    return;
  }
  console.log(key);
  

  const currentpatients = patient.filter(
    (i) =>
      i.firstName?.toLowerCase().includes(key) ||
      i.lastName?.toLowerCase().includes(key) ||
      String(i.primaryNumber ?? "").toLowerCase().includes(key)
  );
  console.log(currentpatients);
  

  setFilterdList(currentpatients);
};


  useEffect(() => {
    handleGetAllTest();
  }, []);

  return (
    <div id="main_content">
      <Header />
      <div className="page">
        <Section />
        <div className="section-body">
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center ">
              <div className="header-action">
                <h1 className="page-title">Patient</h1>
                <ol className="breadcrumb page-breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#">RNDSAN</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Patient
                  </li>
                </ol>
              </div>

              <div
  style={{
    display: "flex",
    alignItems: "center",
    gap: "8px",
    maxWidth: "420px",
    padding: "5px",
    border: "1px solid #d1d5db",
    borderRadius: "8px",
    background: "#fff",
    boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
  }}
>
  <input
    type="text"
    style={{
      flex: 1,
      minWidth: 0,
      padding: "9px 10px",
      border: "none",
      outline: "none",
      fontSize: "14px",
      background: "transparent",
      color: "#111827",
    }}
    placeholder="Search by first name, last name, or phone"
    value={searchKey}
    onChange={(e) => setSearchKey(e.target.value)}
    onKeyDown={(e) => {
      if (e.key === "Enter") handleSearckByKey();
    }}
  />

  <button
    type="button"
    onClick={handleSearckByKey}
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "6px",
      padding: "9px 15px",
      border: "none",
      borderRadius: "6px",
      background: "#2563eb",
      color: "#fff",
      fontSize: "14px",
      fontWeight: 500,
      cursor: "pointer",
      whiteSpace: "nowrap",
    }}
  >
    <span>⌕</span>
    Search
  </button>
</div>
            </div>
          </div>
        </div>

        <div className="section-body mt-4">
          <div className="container-fluid">
            <div className="tab-content">
              <div className="tab-pane active" id="Patient-all">
                <div className="card">
                  {/* <div className="card-body">
                    <div className="row">
                      <div className="col-lg-2 col-md-4 col-sm-6">
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Roll No."
                          />
                        </div>
                      </div>
                      <div className="col-lg-2 col-md-4 col-sm-6">
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Name"
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-4 col-sm-6">
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Department"
                          />
                        </div>
                      </div>
                      <div className="col-lg-2 col-md-4 col-sm-6">
                        <div className="input-group">
                          <input
                            data-provide="datepicker"
                            data-date-autoclose="true"
                            className="form-control"
                            placeholder="Admission Date"
                          />
                        </div>
                      </div>
                      <div className="col-lg-2 col-md-4 col-sm-6">
                        <a
                          href="javascript:void(0);"
                          className="btn btn-sm btn-primary btn-block"
                          title
                        >
                          Search
                        </a>
                      </div>
                    </div>
                  </div> */}
                </div>
                <div className="table-responsive card">
                  <table className="table table-hover js-basic-example dataTable table-striped table_custom border-style spacing5">
                    <thead>
                      <tr>
                        <th style={{ textAlign: "center" }}>ID</th>
                        <th style={{ textAlign: "center" }}>Name</th>
                        <th style={{ textAlign: "center" }}>Gender</th>
                        <th style={{ textAlign: "center" }}>Number</th>
                        <th style={{ textAlign: "center" }}>Blood Group</th>
                        <th style={{ textAlign: "center" }}>State</th>
                        <th style={{ textAlign: "center" }}>Book</th>
                        <th style={{ textAlign: "center" }}>Tests</th>
                        <th style={{ textAlign: "center" }}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredList.length>0?
                       filteredList.map((patient, indx) => (
                        <tr key={patient.id}>
                          <td>{indexOfFirst + indx + 1}</td>
                          <td>
                            {patient.firstName} {patient.middleName}{" "}
                            {patient.lastName}
                          </td>
                          <td>{patient.gender}</td>
                          <td>{patient.primaryNumber}</td>
                          <td>{patient.bloodGroup}</td>
                          <td>{patient.state}</td>
                          <td>
                            <button
                              onClick={() => {
                                setTestModal(patient);
                                console.log(patient);
                              }}
                              type="button"
                              className="btn btn-icon btn-sm"
                              title=""
                              style={{
                                backgroundColor: "#0c8ee6",
                                color: "white",
                              }}
                            >
                              Test
                            </button>
                          </td>

                          <td>
                            <button
                              type="button"
                              className="btn btn-icon btn-sm"
                              title=""
                              style={{
                                backgroundColor: "#0c8ee6",
                                color: "white",
                              }}
                              onClick={() => setAllTestModal(patient)}
                            >
                              Report
                            </button>
                          </td>
                          <td>
                            <button
                              onClick={() => {
                                handleGetPatientById(patient.id);
                                setModal(true);
                              }}
                              type="button"
                              className="btn btn-icon btn-sm"
                              title="View"
                            >
                              <i className="fa fa-eye" />
                            </button>
                          </td>
                        </tr>
                      ))
                      :
                      currentPatients.map((patient, indx) => (
                        <tr key={patient.id}>
                          <td>{indexOfFirst + indx + 1}</td>
                          <td>
                            {patient.firstName} {patient.middleName}{" "}
                            {patient.lastName}
                          </td>
                          <td>{patient.gender}</td>
                          <td>{patient.primaryNumber}</td>
                          <td>{patient.bloodGroup}</td>
                          <td>{patient.state}</td>
                          <td>
                            <button
                              onClick={() => {
                                setTestModal(patient);
                                console.log(patient);
                              }}
                              type="button"
                              className="btn btn-icon btn-sm"
                              title=""
                              style={{
                                backgroundColor: "#0c8ee6",
                                color: "white",
                              }}
                            >
                              Test
                            </button>
                          </td>

                          <td>
                            <button
                              type="button"
                              className="btn btn-icon btn-sm"
                              title=""
                              style={{
                                backgroundColor: "#0c8ee6",
                                color: "white",
                              }}
                              onClick={() => setAllTestModal(patient)}
                            >
                              Report
                            </button>
                          </td>
                          <td>
                            <button
                              onClick={() => {
                                handleGetPatientById(patient.id);
                                setModal(true);
                              }}
                              type="button"
                              className="btn btn-icon btn-sm"
                              title="View"
                            >
                              <i className="fa fa-eye" />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  <div
                    className="pagination mt-3"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <button
                      disabled={currentPage === 1}
                      onClick={() => setCurrentPage((prev) => prev - 1)}
                      className="btn btn-primary btn-sm me-2"
                    >
                      Prev
                    </button>

                    <span>
                      {" "}
                      Page {currentPage} of{" "}
                      {Math.ceil(patient.length / itemsPerPage)}{" "}
                    </span>

                    <button
                      disabled={
                        currentPage === Math.ceil(patient.length / itemsPerPage)
                      }
                      onClick={() => setCurrentPage((prev) => prev + 1)}
                      className="btn btn-primary btn-sm ms-2"
                    >
                      Next
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="section-body">
          <footer className="footer">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  Copyright © 2025{" "}
                  <a href="">Technology support By - Siance Software Pvt Ltd</a>
                  .
                </div>
                {/* <div className="col-md-6 col-sm-12 text-md-right">
                  <ul className="list-inline mb-0">
                    <li className="list-inline-item">
                      <a href="../doc/index.html">Documentation</a>
                    </li>
                    <li className="list-inline-item">
                      <a href="javascript:void(0)">FAQ</a>
                    </li>
                    <li className="list-inline-item">
                      <a
                        href="javascript:void(0)"
                        className="btn btn-outline-primary btn-sm"
                      >
                        Buy Now
                      </a>
                    </li>
                  </ul>
                </div> */}
              </div>
            </div>
          </footer>
        </div>
      </div>

      <div>
        {editModal && (
          <div
            style={{
              position: "absolute",
              top: "250px",
              right: "20vw",
              backgroundColor: "white",
              zIndex: 999,
              padding: "20px",
              borderRadius: "10px",
              border: "0.5px solid gray",
              display: "flex",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                padding: "20px",
                borderRadius: "10px",
                backgroundColor: "rgb(224, 224, 224)",
              }}
            >
              {service.map((item, ind) => {
                const selectedService = selectedServices.find(
                  (s) => s.serviceId === item.id,
                );

                return (
                  <label key={item.id} style={{ display: "block" }}>
                    <p
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        padding: "10px 14px",
                        margin: "8px 0",
                        border: "1px solid #e5e7eb",
                        borderRadius: "8px",
                        background: "#fafafa",
                        cursor: "pointer",
                        fontSize: "15px",
                        fontWeight: "500",
                        color: "#374151",
                      }}
                    >
                      <span style={{ minWidth: "20px", color: "#6b7280" }}>
                        {ind + 1}.
                      </span>

                      <input
                        type="checkbox"
                        checked={!!selectedService}
                        onChange={() => handleServiceChange(item.id)}
                        style={{ width: "16px", height: "16px" }}
                      />

                      <span style={{ flex: 1 }}>{item.serviceName}</span>
                    </p>

                    {/* Audiometer select */}
                    <select
                      disabled={!selectedService}
                      value={selectedService?.audiometerId || ""}
                      onChange={(e) =>
                        handleAudiometerChange(item.id, Number(e.target.value))
                      }
                    >
                      <option value="">Select audiometer</option>
                      {item.audiometers.map((a) => (
                        <option key={a.id} value={a.id}>
                          {a.acHeadPhone}
                        </option>
                      ))}
                    </select>
                  </label>
                );
              })}
              <label>
                <select
                  value={selectedServicePerson}
                  onChange={(e) => {
                    const personId = Number(e.target.value);

                    setSelectedServicePerson(personId);

                    // 🔥 Apply to ALL selected services
                    setSelectedServices((prev) =>
                      prev.map((s) => ({
                        ...s,
                        servicePersonId: personId,
                      })),
                    );
                  }}
                  style={{ padding: "8px", width: "100%" }}
                >
                  <option value="">Select Service Person</option>
                  {serviceBoys.map((i) => (
                    <option key={i.commonuserId} value={i.commonuserId}>
                      {i.firstName}
                    </option>
                  ))}
                </select>
              </label>

              <label>
                Discount Ammount
                <input
                  value={discountAmount}
                  onChange={(e) => setdiscountAmount(e.target.value)}
                />
              </label>

              <p
                onClick={() => handlePersonupdate()}
                style={{
                  padding: "8px",
                  backgroundColor: "black",
                  color: "white",
                  borderRadius: "6px",
                  textAlign: "center",
                  cursor: "pointer",
                }}
              >
                Submit
              </p>
            </div>
            <p
              onClick={() => {
                setEditModal(null);
              }}
              style={{ padding: "10px", cursor: "pointer" }}
            >
              X
            </p>
          </div>
        )}
      </div>

      <div>
        {testModal && (
          <div
            style={{
              position: "fixed",
              inset: 0,
              zIndex: 9999,
              backgroundColor: "rgba(0, 0, 0, 0.55)",
              backdropFilter: "blur(6px)",
              WebkitBackdropFilter: "blur(6px)",
              display: "flex",
              alignItems: "center",
              flexDirection:"column",
              justifyContent: "center",
              padding: "16px",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                position: "sticky",
                top: "0",
                alignSelf: "flex-end",
                marginBottom: "8px",
                cursor: "pointer",
                fontWeight: "600",
                fontSize: "18px",
                zIndex: 10,
                background: "white",
                padding: "4px 8px",
              }}
              onClick={() => setTestModal(null)}
            >
              X
            </div>
            <div
              style={{
                position: "relative",
                width: "100%",
                maxWidth: "1250px",
                maxHeight: "92vh",
                overflowY: "auto",
                overflowX: "auto",
                backgroundColor: "white",
                padding: "20px",
                borderRadius: "12px",
                border: "0.5px solid gray",
                display: "flex",
                flexDirection: "row",
                boxSizing: "border-box",
              }}
            >
              <div
                style={{
                  width: "320px",
                  margin: "20px auto",

                  padding: "10px",
                  fontFamily: "Arial",
                  fontSize: "13px",
                }}
              >
                <div style={{ fontWeight: "bold", marginBottom: "8px" }}>
                  Select Test Services
                </div>

               {service.map((item, i) => {
  const selectedService = selectedServices.find(
    (s) => s.id === item.id,
  );

  return (
    <div
      key={item.id || i}
      style={{
        background: "#dcdcdc",
        padding: "6px",
        borderRadius: "5px",
        marginBottom: "6px",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "4px",
        }}
      >
        <span style={{ width: "16px" }}>{i + 1}.</span>

        <input
          type="checkbox"
          checked={!!selectedService}
          onChange={(e) => handleCheckbox(item, e.target.checked)}
          style={{
            margin: 0,
            transform: "scale(0.9)",
            cursor: "pointer",
            width: "16px",
          }}
        />

        <span style={{ marginLeft: "2px" }}>
          {item?.serviceName}
        </span>
      </div>

      {selectedService && (
        <div style={{ marginTop: "8px", marginLeft: "22px" }}>
          <label
            style={{
              display: "block",
              marginBottom: "4px",
              fontSize: "13px",
            }}
          >
            Select Schedule:
          </label>

          <select
            value={
              selectedService.scheduleStartTime &&
              selectedService.scheduleEndTime
                ? `${selectedService.scheduleStartTime}-${selectedService.scheduleEndTime}`
                : ""
            }
            onChange={(e) => {
              const [scheduleStartTime, scheduleEndTime] =
                e.target.value.split("-");

              setSelectedServices((prev) =>
                prev.map((s) =>
                  s.id === item.id
                    ? {
                        ...s,
                        scheduleStartTime,
                        scheduleEndTime,
                      }
                    : s,
                ),
              );
            }}
            style={{
              width: "100%",
              padding: "5px",
              borderRadius: "4px",
            }}
          >
            <option value="">Select schedule</option>
          

{Array.from({ length: 16 }, (_, i) => {
  const startMinutes = 9 * 60 + i * 30;
  const endMinutes = startMinutes + 30;

  const formatTime = (minutes) => {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;

    return `${String(hours).padStart(2, "0")}:${String(mins).padStart(2, "0")}`;
  };

  const start = formatTime(startMinutes);
  const end = formatTime(endMinutes);

  return (
    <option key={start} value={`${start}-${end}`}>
      {start} - {end}
    </option>
  );
})}
          </select>
        </div>
      )}
    </div>
  );
})}

                {/* Selects */}
                <select
                  style={{
                    width: "100%",
                    marginBottom: "8px",
                    padding: "5px",
                    outline: "none",
                  }}
                  value={selectedservicePersonId}
                  onChange={(e) => setSelectedServicePersonId(e.target.value)}
                >
                  <option value={""}>Select service boy</option>
                  {mediaclTechnician.map((i) => (
                    <option value={i.employeeId}>
                      {i.firstName}({i.district})
                    </option>
                  ))}
                </select>

                <select
                  style={{
                    width: "100%",
                    marginBottom: "8px",
                    padding: "5px",
                    outline: "none",
                  }}
                  value={selectedStoreId}
                  onChange={(e) => setselectedStoreId(e.target.value)}
                >
                  <option value={""}>Select store</option>
                  {storeList.map((i) => (
                    <option value={i.id}>
                      {i.storeName}({i.storeAddress})
                    </option>
                  ))}
                </select>

                {/* Date */}
                <div style={{ marginBottom: "4px" }}>Appointment Date</div>
                <input
                  type="date"
                  style={{ width: "100%", padding: "5px", marginBottom: "8px" }}
                />

                {/* Refer */}
                <div style={{ marginBottom: "4px" }}>Select Refer</div>

               
<div style={{ marginBottom: "6px" }}>
  <input
    type="checkbox"
    checked={isAgent}
    onChange={(e) => {
      const checked = e.target.checked;
      setIsAgent(checked);

      if (!checked) {
        setRefers((prev) =>
          prev.filter((r) => r.type !== "Agent"),
        );
        setselectedAgent("");
      }
    }}
    style={{ width: "16px", margin: 0 }}
  />{" "}
  Agent
</div>

{isAgent && (
  <div style={{ marginLeft: "15px", marginBottom: "8px" }}>
    <div style={{ marginBottom: "4px" }}>Select Agents:</div>

    <select
      style={{ width: "100%", padding: "5px" }}
      value=""
      onChange={(e) => {
        const value = e.target.value;
        if (!value) return;

        const obj = agentList.find(
          (i) => String(i.commonUserId) === value
        );

        if (!obj) return;

        setRefers((prev) => {
          // Prevent selecting the same Agent twice
          if (
            prev.some(
              (r) =>
                r.type === "Agent" &&
                r.commonUserId === obj.commonUserId
            )
          ) {
            return prev;
          }

          return [
            ...prev,
            {
              commonUserId: obj.commonUserId,
              name: obj.firstName,
              type: "Agent",
            },
          ];
        });
      }}
    >
      <option value="">Select agent</option>

      {agentList.map((i) => (
        <option
          key={i.commonUserId}
          value={String(i.commonUserId)}
        >
          {i.firstName}
        </option>
      ))}
    </select>

    {/* Display selected Agents with individual remove buttons */}
    {refers
      .filter((r) => r.type === "Agent")
      .map((agent) => (
        <div
          key={agent.commonUserId}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            background: "#e6e6e6",
            padding: "6px 8px",
            marginTop: "5px",
            borderRadius: "5px",
          }}
        >
          <span>{agent.name}</span>

          <button
            type="button"
            onClick={() =>
              setRefers((prev) =>
                prev.filter(
                  (r) =>
                    !(
                      r.type === "Agent" &&
                      r.commonUserId === agent.commonUserId
                    )
                )
              )
            }
            style={{
              border: "none",
              background: "transparent",
              color: "red",
              cursor: "pointer",
              fontWeight: "bold",
            }}
          >
            ×
          </button>
        </div>
      ))}
  </div>
)}


                <div style={{ marginBottom: "6px" }}>
                  <input
                    type="checkbox"
                    checked={isDiagnostic}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      setIsDiagnostic(checked);

                      // if unchecked → remove all Agent type
                      if (!checked) {
                        setRefers((prev) =>
                          prev.filter((r) => r.type !== "DiagnosticCenter"),
                        );
                      }
                    }}
                    style={{ width: "16px", margin: 0 }}
                  />{" "}
                  Diagnostic Center
                </div>
               
{isDiagnostic && (
  <div style={{ marginLeft: "15px", marginBottom: "8px" }}>
    <div style={{ marginBottom: "4px" }}>Select Diagnostic Centers:</div>

    <select
      style={{ width: "100%", padding: "5px" }}
      value=""
      onChange={(e) => {
        const value = e.target.value;
        if (!value) return;

        const obj = diagnostic.find(
          (i) => String(i.commonUserId) === value &&
            !refers.some(
              (r) =>
                r.type === "DiagnosticCenter" &&
                r.commonUserId === i.commonUserId
            )
        );

        // Find the selected diagnostic center by its unique ID
        const selectedObj = diagnostic.find(
          (i) => String(i.id) === value
        );

        const center = selectedObj || obj;
        if (!center) return;

        const owner = user.find(
          (p) => p.id === center.commonUserId
        );

        setRefers((prev) => {
          if (
            prev.some(
              (r) =>
                r.type === "DiagnosticCenter" &&
                r.commonUserId === center.commonUserId
            )
          ) {
            return prev;
          }

          return [
            ...prev,
            {
              commonUserId: center.commonUserId,
              name: owner?.firstName || center.diagnosticCenterName,
              type: "DiagnosticCenter",
            },
          ];
        });
      }}
    >
      <option value="">Select diagnostic center</option>

      {diagnostic.map((i, index) => (
        <option key={i.id || index} value={String(i.id)}>
          {i.diagnosticCenterName} (
          {user.find((p) => i.commonUserId === p.id)?.firstName})
        </option>
      ))}
    </select>

    {refers
      .filter((r) => r.type === "DiagnosticCenter")
      .map((center) => (
        <div
          key={center.commonUserId}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            background: "#e6e6e6",
            padding: "6px 8px",
            marginTop: "5px",
            borderRadius: "5px",
          }}
        >
          <span>{center.name}</span>

          <button
            type="button"
            onClick={() =>
              setRefers((prev) =>
                prev.filter(
                  (r) =>
                    !(
                      r.type === "DiagnosticCenter" &&
                      r.commonUserId === center.commonUserId
                    )
                )
              )
            }
            style={{
              border: "none",
              background: "transparent",
              color: "red",
              cursor: "pointer",
              fontWeight: "bold",
            }}
          >
            ×
          </button>
        </div>
      ))}
  </div>
)}


                <div style={{ marginBottom: "6px" }}>
                  <input
                    type="checkbox"
                    checked={isDoctor}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      setIsDoctor(checked);

                      // if unchecked → remove all Agent type
                      if (!checked) {
                        setRefers((prev) =>
                          prev.filter((r) => r.type !== "Doctor"),
                        );
                      }
                    }}
                    style={{ width: "16px", margin: 0 }}
                  />{" "}
                  Doctor
                </div>

                {isDoctor && (
  <div style={{ marginLeft: "15px", marginBottom: "8px" }}>
    <div style={{ marginBottom: "4px" }}>Select Doctor:</div>

    <select
      style={{ width: "100%", padding: "5px" }}
      value=""
      onChange={(e) => {
        const value = e.target.value;
        if (!value) return;

        const obj = doctors.find(
          (i) => String(i.commonUserId) === value,
        );

        if (!obj) return;

        const newReferral = {
          commonUserId: obj.commonUserId,
          name: obj.firstName,
          type: "Doctor",
        };

        setRefers((prev) => {
          const alreadyExists = prev.some(
            (r) =>
              r.type === "Doctor" &&
              r.commonUserId === newReferral.commonUserId,
          );

          if (alreadyExists) return prev;

          return [...prev, newReferral];
        });
      }}
    >
      <option value="">Select doctor</option>

      {doctors.map((i) => (
        <option key={i.commonUserId} value={String(i.commonUserId)}>
          {user.find((p) => i.commonUserId === p.id)?.firstName ||
            "Unknown"}
        </option>
      ))}
    </select>

    <div style={{ marginTop: "8px" }}>
      {refers
        .filter((r) => r.type === "Doctor")
        .map((doctor) => (
          <div
            key={doctor.commonUserId}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "6px 10px",
              marginBottom: "5px",
              background: "#f1f1f1",
              borderRadius: "5px",
            }}
          >
            <span>{doctor.name}</span>

            <button
              type="button"
              onClick={() =>
                setRefers((prev) =>
                  prev.filter(
                    (r) =>
                      !(
                        r.type === "Doctor" &&
                        r.commonUserId === doctor.commonUserId
                      ),
                  ),
                )
              }
              style={{
                border: "none",
                background: "transparent",
                color: "red",
                cursor: "pointer",
                fontSize: "18px",
              }}
            >
              ×
            </button>
          </div>
        ))}
    </div>
  </div>
)}

                <div>
                  {" "}
                  <input
                    type="checkbox"
                    checked={isHospital}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      setIsHospital(checked);

                      // if unchecked → remove all Agent type
                      if (!checked) {
                        setRefers((prev) =>
                          prev.filter((r) => r.type !== "Hospital"),
                        );
                      }
                    }}
                    style={{ width: "16px", margin: 0 }}
                  />{" "}
                  Hospital
                </div>
               {isHospital && (
  <div style={{ marginLeft: "15px", marginBottom: "8px" }}>
    <div style={{ marginBottom: "4px" }}>Select Hospital:</div>

    <select
      style={{ width: "100%", padding: "5px" }}
      value=""
      onChange={(e) => {
        const value = e.target.value;
        if (!value) return;

        const obj = hospital.find(
          (i) => String(i.commonUserId) === value,
        );

        if (!obj) return;

        const newReferral = {
          commonUserId: obj.commonUserId,
          name: obj.hospitalName,
          type: "Hospital",
        };

        setRefers((prev) => {
          const alreadyExists = prev.some(
            (r) =>
              r.type === "Hospital" &&
              r.commonUserId === newReferral.commonUserId,
          );

          if (alreadyExists) return prev;

          return [...prev, newReferral];
        });
      }}
    >
      <option value="">Select hospital</option>

      {hospital.map((i) => (
        <option key={i.commonUserId} value={String(i.commonUserId)}>
          {i.hospitalName} (
          {user.find((p) => i.commonUserId === p.id)?.firstName ||
            "Unknown"}
          )
        </option>
      ))}
    </select>

    <div style={{ marginTop: "8px" }}>
      {refers
        .filter((r) => r.type === "Hospital")
        .map((hospitalItem) => (
          <div
            key={hospitalItem.commonUserId}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "6px 10px",
              marginBottom: "5px",
              background: "#f1f1f1",
              borderRadius: "5px",
            }}
          >
            <span>{hospitalItem.name}</span>

            <button
              type="button"
              onClick={() =>
                setRefers((prev) =>
                  prev.filter(
                    (r) =>
                      !(
                        r.type === "Hospital" &&
                        r.commonUserId === hospitalItem.commonUserId
                      ),
                  ),
                )
              }
              style={{
                border: "none",
                background: "transparent",
                color: "red",
                cursor: "pointer",
                fontSize: "18px",
              }}
            >
              ×
            </button>
          </div>
        ))}
    </div>
  </div>
)}
                <div>
                  {" "}
                  <input
                    type="checkbox"
                    checked={isShop}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      setIsShop(checked);

                      // if unchecked → remove all Agent type
                      if (!checked) {
                        setRefers((prev) =>
                          prev.filter((r) => r.type !== "Shop"),
                        );
                      }
                    }}
                    style={{ width: "16px", margin: 0 }}
                  />{" "}
                  Shop
                </div>
                {isShop && (
  <div style={{ marginLeft: "15px", marginBottom: "8px" }}>
    <div style={{ marginBottom: "4px" }}>Select Shop:</div>

    <select
      style={{ width: "100%", padding: "5px" }}
      value=""
      onChange={(e) => {
        const value = e.target.value;
        if (!value) return;

        const obj = shop.find(
          (i) => String(i.commonUserId) === value,
        );

        if (!obj) return;

        const newReferral = {
          commonUserId: obj.commonUserId,
          name: obj.shopName,
          type: "Shop",
        };

        setRefers((prev) => {
          const alreadyExists = prev.some(
            (r) =>
              r.type === "Shop" &&
              r.commonUserId === newReferral.commonUserId,
          );

          if (alreadyExists) return prev;

          return [...prev, newReferral];
        });
      }}
    >
      <option value="">Select shop</option>

      {shop.map((i) => (
        <option key={i.commonUserId} value={String(i.commonUserId)}>
          {i.shopName} (
          {user.find((p) => i.commonUserId === p.id)?.firstName ||
            "Unknown"}
          )
        </option>
      ))}
    </select>

    <div style={{ marginTop: "8px" }}>
      {refers
        .filter((r) => r.type === "Shop")
        .map((shopItem) => (
          <div
            key={shopItem.commonUserId}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "6px 10px",
              marginBottom: "5px",
              background: "#f1f1f1",
              borderRadius: "5px",
            }}
          >
            <span>{shopItem.name}</span>

            <button
              type="button"
              onClick={() =>
                setRefers((prev) =>
                  prev.filter(
                    (r) =>
                      !(
                        r.type === "Shop" &&
                        r.commonUserId === shopItem.commonUserId
                      ),
                  ),
                )
              }
              style={{
                border: "none",
                background: "transparent",
                color: "red",
                cursor: "pointer",
                fontSize: "18px",
              }}
            >
              ×
            </button>
          </div>
        ))}
    </div>
  </div>
)}
                <div>
                  {" "}
                  <input
                    type="checkbox"
                    checked={isStore}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      setIsStore(checked);

                      // if unchecked → remove all Agent type
                      if (!checked) {
                        setRefers((prev) =>
                          prev.filter((r) => r.type !== "Store"),
                        );
                      }
                    }}
                    style={{ width: "16px", margin: 0 }}
                  />{" "}
                  Store
                </div>
               {isStore && (
  <div style={{ marginLeft: "15px", marginBottom: "8px" }}>
    <div style={{ marginBottom: "4px" }}>Select Store:</div>

    <select
      style={{ width: "100%", padding: "5px" }}
      value=""
      onChange={(e) => {
        const value = e.target.value;
        if (!value) return;

        const obj = storeOwner.find(
          (i) => String(i.commonUserId) === value,
        );

        if (!obj) return;

        const newReferral = {
          commonUserId: obj.commonUserId,
          name: obj.storeName,
          type: "Store",
        };

        setRefers((prev) => {
          const alreadyExists = prev.some(
            (r) =>
              r.type === "Store" &&
              r.commonUserId === newReferral.commonUserId,
          );

          if (alreadyExists) return prev;

          return [...prev, newReferral];
        });
      }}
    >
      <option value="">Select store</option>

      {storeOwner.map((i) => (
        <option key={i.commonUserId} value={String(i.commonUserId)}>
          {i.storeName} (
          {user.find((p) => i.commonUserId === p.id)?.firstName ||
            "Unknown"}
          )
        </option>
      ))}
    </select>

    <div style={{ marginTop: "8px" }}>
      {refers
        .filter((r) => r.type === "Store")
        .map((storeItem) => (
          <div
            key={storeItem.commonUserId}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "6px 10px",
              marginBottom: "5px",
              background: "#f1f1f1",
              borderRadius: "5px",
            }}
          >
            <span>{storeItem.name}</span>

            <button
              type="button"
              onClick={() =>
                setRefers((prev) =>
                  prev.filter(
                    (r) =>
                      !(
                        r.type === "Store" &&
                        r.commonUserId === storeItem.commonUserId
                      ),
                  ),
                )
              }
              style={{
                border: "none",
                background: "transparent",
                color: "red",
                cursor: "pointer",
                fontSize: "18px",
              }}
            >
              ×
            </button>
          </div>
        ))}
    </div>
  </div>
)}
                <div style={{ marginBottom: "8px" }}>
                  <input
                    type="checkbox"
                    checked={isVendor}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      setIsVendor(checked);

                      // if unchecked → remove all Agent type
                      if (!checked) {
                        setRefers((prev) =>
                          prev.filter((r) => r.type !== "Vendor"),
                        );
                      }
                    }}
                    style={{ width: "16px", margin: 0 }}
                  />{" "}
                  Vendor
                </div>
               {isVendor && (
  <div style={{ marginLeft: "15px", marginBottom: "8px" }}>
    <div style={{ marginBottom: "4px" }}>Select Vendor:</div>

    <select
      style={{ width: "100%", padding: "5px" }}
      value=""
      onChange={(e) => {
        const value = e.target.value;
        if (!value) return;

        const obj = vendor.find(
          (i) => String(i.commonUserId) === value,
        );

        if (!obj) return;

        const newReferral = {
          commonUserId: obj.commonUserId,
          name: obj.firstName,
          type: "Vendor",
        };

        setRefers((prev) => {
          const alreadyExists = prev.some(
            (r) =>
              r.type === "Vendor" &&
              r.commonUserId === newReferral.commonUserId,
          );

          if (alreadyExists) return prev;

          return [...prev, newReferral];
        });
      }}
    >
      <option value="">Select vendor</option>

      {vendor.map((i) => (
        <option key={i.commonUserId} value={String(i.commonUserId)}>
          {user.find((p) => i.commonUserId === p.id)?.firstName ||
            "Unknown"}
        </option>
      ))}
    </select>

    <div style={{ marginTop: "8px" }}>
      {refers
        .filter((r) => r.type === "Vendor")
        .map((vendorItem) => (
          <div
            key={vendorItem.commonUserId}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "6px 10px",
              marginBottom: "5px",
              background: "#f1f1f1",
              borderRadius: "5px",
            }}
          >
            <span>{vendorItem.name}</span>

            <button
              type="button"
              onClick={() =>
                setRefers((prev) =>
                  prev.filter(
                    (r) =>
                      !(
                        r.type === "Vendor" &&
                        r.commonUserId === vendorItem.commonUserId
                      ),
                  ),
                )
              }
              style={{
                border: "none",
                background: "transparent",
                color: "red",
                cursor: "pointer",
                fontSize: "18px",
              }}
            >
              ×
            </button>
          </div>
        ))}
    </div>
  </div>
)}

                {/* Price */}
                <div style={{ marginBottom: "6px",fontWeight:"600" }}>
                  Total Price: {totalPrice}
                </div>

                <div style={{ marginBottom: "4px" }}>Discount Amount</div>
                <input
                  type="number"
                  style={{ width: "100%", padding: "5px", marginBottom: "8px" }}
                  value={discount}
                  onChange={(e) => {
                    setDiscount(e.target.value);
                  }}
                />

                <div style={{ marginBottom: "4px" }}>Advance Amount</div>
                <input
                  type="number"
                  style={{
                    width: "100%",
                    padding: "5px",
                    marginBottom: "10px",
                  }}
                  value={advance}
                  onChange={(e) => setAdvance(e.target.value)}
                />
              </div>

              <div
                style={{
                  width: "600px",
                  margin: "20px auto",
                  padding: "10px",
                  fontFamily: "Arial",
                  color: "#1a2a6c",
                }}
              >
                {/* Header */}
                <div style={{ textAlign: "center", position: "relative" }}>
                  <div style={{ position: "absolute", left: "0" }}>
                    <h3 style={{ margin: 0 }}>AudiBle</h3>
                    <small>BYH</small>
                  </div>

                  <div>
                    <b>AudiBle unit of RNDSAN Pvt Ltd</b>
                    <div>H.O.Room No-7,Ground Floor,Phase-3,</div>
                    <div>simurali Multiplex,Nadia-741248,WB</div>
                  </div>
                </div>

                <hr style={{ border: "1px solid #1a2a6c" }} />

                {/* Patient Info */}
                <div style={box}>
                  <div style={row}>
                    <div>
                      <span style={label}>
                        Current Time: {new Date().toLocaleString()}
                      </span>
                    </div>
                  </div>

                  <div style={row}>
                    <div>
                      <span style={label}>Name:</span>
                      {testModal?.firstName} {testModal?.lastName}
                    </div>
                    <div>
                      <span style={label}>DOB:</span>
                      {
                        (user?.find((p) => p.id === testModal.commonUserId))
                          .dob[0]
                      }
                      /
                      {user.find((p) => p.id === testModal.commonUserId).dob[1]}
                      /
                      {user.find((p) => p.id === testModal.commonUserId).dob[2]}
                    </div>
                  </div>

                  <div style={row}>
                    <div>
                      <span style={label}>Mobile:</span> 1st-{" "}
                      {
                        user.find((p) => p.id === testModal.commonUserId)
                          .primaryNumber
                      }
                    </div>
                  </div>

                  <div style={row}>
                    <div>
                      <span style={label}>Address:</span>
                      {
                        user.find((p) => p.id === testModal.commonUserId)
                          .villageTownCity
                      }
                      ,{user.find((p) => p.id === testModal.commonUserId).state}
                    </div>
                    <div>
                      <span style={label}>Pin:</span>{" "}
                      {
                        user.find((p) => p.id === testModal.commonUserId)
                          .pincode
                      }
                    </div>
                  </div>
                </div>

                {/* Refer Section 1 */}
                {refers.map((i) => (
                  <div style={box}>
                    <div style={row}>
                      <div>
                        <span style={label}>Refer By:</span> {i.name}(
                        {user.find((p) => p.id === i.commonUserId).firstName})
                      </div>
                      <div>
                        <span style={label}>Type: </span>
                        {i.type}
                      </div>
                    </div>

                    <div style={row}>
                      <div>
                        <span style={label}>Chamber:</span>{" "}
                        {
                          user.find((p) => p.id === i.commonUserId)
                            .villageTownCity
                        }
                      </div>
                      <div>
                        <span style={label}>Address:</span>{" "}
                        {user.find((p) => p.id === i.commonUserId).district}
                      </div>
                    </div>
                  </div>
                ))}

                {/* Table */}
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    marginBottom: "6px",
                  }}
                >
                  <thead>
                    <tr>
                      <th style={tableCell}>Sl No.</th>
                      <th style={tableCell}>Particulars</th>
                      <th style={tableCell}>Amount</th>
                        <th style={tableCell}>Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedServices.map((i, ind) => (
                      <tr>
                        <td style={tableCell}>{ind + 1}</td>
                        <td style={tableCell}>{i?.serviceName}</td>
                        <td style={tableCell}>{i?.servicePrice}</td>
                        <td style={tableCell}>{i?.scheduleStartTime} - {i?.scheduleEndTime}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                {/* GST + Total */}
                <div style={{ display: "flex", border: "1px solid #1a2a6c" }}>
                  <div
                    style={{
                      flex: 1,
                      padding: "8px",
                      borderRight: "1px solid #1a2a6c",
                    }}
                  >
                    <div>
                      <b>GST NO:19AAMCR5729G1ZW</b>
                    </div>
                  </div>

                  <div style={{ width: "250px" }}>
                    {[
                      ["Total", totalPrice],
                      ["Discount", discount],
                      ["GST", "0"],
                      ["Grand Total", totalPrice - discount],
                      ["Advance", advance],
                    ].map((item, i) => (
                      <div
                        key={i}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          borderBottom: "1px solid #1a2a6c",
                          padding: "6px",
                          fontSize: "14px",
                        }}
                      >
                        <div>{item[0]}</div>
                        <div>{item[1]}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <button
              style={{
                width: "100%",
                background: "black",
                color: "white",
                padding: "8px",
                border: "none",
                cursor: "pointer",
                borderRadius:"10px",
                margin:"10px"
              }}
              onClick={() => handleTestBookSubmit()}
            >
              Submit
            </button>
          </div>
        )}
      </div>

      <div>
        {allTestModal && (
          <div
            style={{
              position: "absolute",
              top: "250px",
              right: "20vw",
              backgroundColor: "white",
              zIndex: 999,
              padding: "20px",
              borderRadius: "10px",
              border: "0.5px solid gray",
              display: "flex",
              height: "100vh",
            }}
          >
            <div
              style={{
                position: "absolute",
                right: "10px",
                top: "10px",
                cursor: "pointer",
              }}
              onClick={() => setAllTestModal(null)}
            >
              X
            </div>
            <div style={{ height: "100%", overflowY: "auto" }}>
              {allBookedTest
                .filter((i) => i.patientId === allTestModal.id)
                .map((bill) => (
                  <div
                    key={bill.id}
                    style={{
                      width: "700px",
                      border: "1px solid black",
                      padding: "10px",
                      fontSize: "13px",
                      fontFamily: "Arial",
                      marginBottom: "20px",
                    }}
                  >
                    {/* HEADER */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div>Date: {bill.billDate}</div>
                      <div>Aadhar: ----</div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div>Name: {bill.patient.name}</div>
                      <div>DOB: ---</div>
                      <div>Gen: Male</div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div>Mobile: {bill.patient.phone}</div>
                      <div>2nd: ----</div>
                      <div>Pin: ----</div>
                    </div>

                    {/* REFERRAL */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        borderBottom: "1px solid black",
                        paddingBottom: "4px",
                        marginBottom: "4px",
                      }}
                    >
                      <div>Refer By: Rahul</div>
                      <div>Apo.Dt: ----</div>
                      <div>Sl: ----</div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        borderBottom: "1px solid black",
                        paddingBottom: "4px",
                        marginBottom: "4px",
                      }}
                    >
                      <div>Chamber: Kolkata</div>
                      <div>Address: {bill.patient.address}</div>
                    </div>

                    {/* TABLE */}
                    <table
                      style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        marginTop: "10px",
                      }}
                    >
                      <thead>
                        <tr>
                          <th
                            style={{
                              border: "1px solid black",
                              padding: "5px",
                            }}
                          >
                            Sl No
                          </th>
                          <th
                            style={{
                              border: "1px solid black",
                              padding: "5px",
                            }}
                          >
                            Particulars
                          </th>
                          <th
                            style={{
                              border: "1px solid black",
                              padding: "5px",
                            }}
                          >
                            Amount
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {bill.services.map((s, i) => (
                          <tr key={i}>
                            <td
                              style={{
                                border: "1px solid black",
                                textAlign: "center",
                              }}
                            >
                              {i + 1}
                            </td>
                            <td
                              style={{
                                border: "1px solid black",
                                textAlign: "center",
                              }}
                            >
                              {s.name}
                            </td>
                            <td
                              style={{
                                border: "1px solid black",
                                textAlign: "center",
                              }}
                            >
                              {s.price || "-"}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>

                    {/* GST + TOTAL */}
                    <div
                      style={{
                        display: "flex",
                        border: "1px solid black",
                        marginTop: "10px",
                      }}
                    >
                      {/* LEFT */}
                      <div
                        style={{
                          width: "50%",
                          borderRight: "1px solid black",
                          padding: "8px",
                        }}
                      >
                        <p>GST NO: 19AAMCR5729G1ZW</p>
                        <p>CGST: --%</p>
                        <p>SGST: --%</p>
                        <p>IGST: --%</p>
                        <p>Total GST: --</p>
                      </div>

                      {/* RIGHT */}
                      <div style={{ width: "50%", padding: "8px" }}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <span>Total</span>
                          <span>{bill.totalAmountWithoutGst}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <span>Discount</span>
                          <span>{bill.discountAmount}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <span>GST</span>
                          <span>--</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            fontWeight: "bold",
                          }}
                        >
                          <span>Grand Total</span>
                          <span>{bill.grandTotalAmount}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <span>Advance</span>
                          <span>{bill.paidAmount || 0}</span>
                        </div>
                      </div>
                    </div>

                    {/* PAYMENT */}
                    <div
                      style={{
                        marginTop: "10px",
                        borderTop: "1px solid black",
                        paddingTop: "5px",
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      MOP:
                      <label>
                        <input type="checkbox" /> Cash
                      </label>
                      <label>
                        <input type="checkbox" /> Card
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          checked={bill.paymentMode === "UPI"}
                          readOnly
                        />
                        UPI
                      </label>
                      <span style={{ marginLeft: "auto" }}>Ref No: ----</span>
                    </div>

                    {/* FOOTER */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: "20px",
                      }}
                    >
                      <div>Patient</div>
                      <div>Authorised Signature</div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        )}
      </div>

      <div>
        {modal && (
          <div
            style={{
              position: "absolute",
              top: "250px",
              right: "20vw",
              backgroundColor: "white",
              zIndex: 999,
              padding: "20px",
              borderRadius: "10px",
              border: "0.5px solid gray",
              display: "flex",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                padding: "20px",
                borderRadius: "10px",
                backgroundColor: "rgb(224, 224, 224)",
              }}
            >
              <p>
                {currentpatient?.firstName} {currentpatient?.middleName}{" "}
                {currentpatient?.lastName}
              </p>
              <p>Age: {currentpatient?.age}</p>
              <p>Address: {currentpatient?.houseBuildingApartment}</p>
              <p>
                Location: {currentpatient?.areaLocalitySector}
                {"  "}, {currentpatient?.landmark}
              </p>
              <p>Vill/Town: {currentpatient?.villageTownCity}</p>
              <p>P.O: {currentpatient?.postOffice}</p>
              <p>Pincode: {currentpatient?.pincode}</p>
              <p>Dist. : {currentpatient?.district}</p>
              <p style={{ fontSize: "16px", fontWeight: "700" }}>Referrals :</p>
              {currentpatient?.referredByList.map((item, ind) => (
                <div style={{ display: "flex", gap: "30px" }}>
                  <p>{item?.referredByName}</p>
                  <p style={{ fontSize: "14px" }}>({item?.remarks})</p>
                </div>
              ))}
            </div>
            <p
              onClick={() => {
                setModal(false);
                setCurrentpatient(null);
              }}
              style={{ padding: "10px", cursor: "pointer" }}
            >
              X
            </p>
          </div>
        )}
      </div>
    </div>
  );
};
export default Patient;
